export default __webpack_public_path__ + "static/2-59673ccea93067d1b5bc414b4b2ae68c.jpg";